module.exports = "/_next/static/images/plane2-duotone-fc2862ac08a9875e8c9ed4a9d6296917.svg";